import { uuid } from '@/_core/utils/uuid';
import { BoardUserActivityType } from '@/api/workspaceSettings/queries';
import { RestoreCardFromTrash } from '../../../store/actions/trash/restoreCardFromTrash';
import { CardType, RestoreDeletedCard } from '..';
import * as storymapStoreModule from '../../../store';

export const createRestoreDeletedCardCommand = async (action: RestoreCardFromTrash) => {
    const store = storymapStoreModule.useStorymapStore();
    const activityId = await uuid.create();
    const row = action.row;

    const boardActivity: any = {
        CardId: row.id,
        CardName: row.title,
        Datetime: new Date().toJSON(),
        OriginalContent: row.title,
        Id: activityId,
        StorymapId: store.state.id,
        WorkspaceId: initAppData.currentWs.workspaceId,
        UserId: initAppData.currentUser.currentUserShortId,
        Username: initAppData.currentUser.currentUserFullName,
        Type: getRestoreActivityType(row.cardType),
    };

    const command = new RestoreDeletedCard(store.state.id, row.id, row.title, row.cardType as CardType);
    command.BoardActivity = boardActivity;

    return command;
};

const getRestoreActivityType = (cardType: number): BoardUserActivityType => {
    switch (cardType) {
        case CardType.Activity:
            return BoardUserActivityType.ActivityRestoredFromTrash;
        case CardType.Task:
            return BoardUserActivityType.TaskRestoredFromTrash;
        case CardType.Subtask:
            return BoardUserActivityType.SubtaskRestoredFromTrash;
        case CardType.UnscheduledSubtask:
            return BoardUserActivityType.UnscheduledSubtaskRestoredFromTrash;
        default:
            return BoardUserActivityType.DoNotSaveThis;
    }
};
